import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-store-redirect',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './store-redirect.component.html',
  styleUrls: ['./store-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreRedirectComponent {

  constructor() {}

  ngOnInit(): void {
    this.redirectToStore();
  }

  redirectToStore(): void {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any)['opera'];

    if (/android/i.test(userAgent)) {
      // google play url
      window.location.href = 'https://play.google.com/store/apps/details?id=com.hostel_hop_inc.hostel_hop_mobile';

      return;
    }

    window.location.href = 'https://apps.apple.com/us/app/hostel-hop/id6473739477';
    return;

    // if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any)['MSStream']) {
    //   // app store url
    //   window.location.href = 'https://apps.apple.com/us/app/hostel-hop/id6473739477';
    //   return;
    // }

    // // Default redirect if device not detected or is a desktop
    // window.location.href = '';
  }
}
